<template>
  <div>

  </div>
</template>

<script>
import {
  BAvatar,
  BButton,
  BCard,
  BCardBody,
  BCardHeader,
  BCardText,
  BCardTitle,
  BCol,
  BImg,
  BLink,
  BMedia,
  BMediaAside,
  BMediaBody,
  BProgress,
  BRow,
  BTab,
  BTabs
} from "bootstrap-vue";
import VuePdfApp from 'vue-pdf-app'
import 'vue-pdf-app/dist/icons/main.css'
import Select2 from 'v-select2-component'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue';
import Ripple from 'vue-ripple-directive'
import {kFormatter} from '@core/utils/filter'
import VueApexCharts from 'vue-apexcharts'
import StatisticCardVertical from '@core/components/statistics-cards/StatisticCardVertical.vue'
import StatisticCardHorizontal from '@core/components/statistics-cards/StatisticCardHorizontal.vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import {PolarArea} from 'vue-chartjs'

const $barColor = '#f3f3f3'
const $trackBgColor = '#EBEBEB'
const $earningsStrokeColor2 = '#ED1F2466'
const $earningsStrokeColor3 = '#ED1F2433'
const chartColors = {
  column: {
    series1: '#826af9',
    series2: '#d2b0ff',
    bg: '#f8d3ff',
  },
  success: {
    shade_100: '#7eefc7',
    shade_200: '#06774f',
  },
  donut: {
    series1: '#ffe700',
    series2: '#00d4bd',
    series3: '#826bf8',
    series4: '#2b9bf4',
    series5: '#FFA1A1',
  },
  area: {
    series3: '#a4f8cd',
    series2: '#60f2ca',
    series1: '#2bdac7',
  },
}

export default {
  components: {
    BProgress,
    PolarArea,
    AppTimeline,
    AppTimelineItem,
    StatisticCardHorizontal,
    StatisticCardVertical,
    VueApexCharts,
    BMedia,
    BMediaAside,
    BAvatar,
    BMediaBody,
    BLink,
    BImg,
    BCardHeader,
    BButton,
    BCardBody,
    BCardTitle,
    kFormatter,
    Ripple,
    BRow,
    BCol,
    VuePdfApp,
    Select2,
    BCard,
    flatPickr,
    BTab,
    BCardText,
    BTabs,
    FeatherIcon
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      isLoading: false,

    };
  },
  watch: {},
  mounted() {

  },
  destroyed() {

  },
  created() {

  },
  methods: {
    getTypeNameStep(data) {
      if (data.step == 1) return `Tìm kiếm - ${data.c}`;
      if (data.step == 2) return `Chọn gói - ${data.c}`;
      if (data.step == 3) return `Nhập thông - ${data.c}`;
      return `Thanh toán - ${data.c}`;
    },
    changeFromDate(e) {
      this.fromDate = e;
      this.loadData();
    },
    changeToDate(e) {
      this.toDate = e;
      this.loadData();
    },
    loadData() {

    },
    kFormatter,
  }
};
</script>
<style lang="scss">
@import "@core/scss/vue/pages/dashboard-ecommerce.scss";
@import "@core/scss/vue/libs/chart-apex.scss";

.center-chart {
  display: flex;
  justify-content: center;
  padding: 20px 0;
}
</style>
